<template>
    <label v-for="value in optionsOrder" :key="value" class="form__control radio-option">
        <Field type="radio" :name="name" :value="value" v-model="computedModelValue" :rules="rules"/>
        {{ options[value] }}
    </label>
</template>

<script>
import {Field} from "vee-validate";
import {computed} from 'vue'

export default {
    name: "RadioGroup",
    components: {Field},
    emits: ['update:modelValue'],
    props: {
        name: {
            type: String,
            required: true
        },
        modelValue: {
            type: [String, Number],
            required: false
        },
        options: { // Object of {value: label} structure
            type: Object,
            required: true
        },
        optionsSortOrder: { // Array of values according to which the options will be sorted and rendered
            type: Array,
            required: false,
            default: undefined
        },
        rules: {
            type: Object,
            required: false,
            default: null
        }
    },
    setup(props, context) {
        const computedModelValue = computed({
            get() {
                return String(props.modelValue)
            },
            set(value) {
                context.emit('update:modelValue', value)
            }
        })
        return {
            computedModelValue
        }
    },
    computed: {
        optionsOrder() {
            return this.optionsSortOrder ? this.optionsSortOrder.map(String) : Object.keys(this.options)
        }
    }
}
</script>
